import { useQuery } from '@tanstack/react-query'
import { fetchSinglePatient } from '../services/patient';
import { useParams } from 'react-router-dom';

const GetSinglePatient = () => {
  const { pommeId } = useParams();
  // Get patient ID from URL params or localStorage
  const patientId = pommeId || localStorage.getItem('patient');

  const getSinglePatient = useQuery({
    queryKey: ['single_patient_profile', patientId],
    queryFn: () => fetchSinglePatient(patientId),
    enabled: !!patientId, // Only run query if we have a patient ID
  })
  return getSinglePatient;
}

export default GetSinglePatient